import anime from "animejs";
import { ESearchWizardSteps } from "../../shared/enums/search.enums";
import {
  clearSearchTerm,
  setSearchView,
  ISearchModeState,
  updateSearchModeState,
  IAdminModeState,
  updateAdminModeState,
} from "../../state-management/slices/global/global.slice";
import {
  clearSearchedOutages,
  clearSubmittedOutage,
  ISubmittedOutage,
} from "../../state-management/slices/outages/outages.slice";
import { AppDispatch } from "../../state-management/store";
import Theme from "../../theme";

const { outageDrawerWidth } = Theme.CE_THEME.layoutProperties;

export const openDrawer = (isMobile: boolean): void => {
  const openTimeline = anime.timeline({
    easing: "easeOutCubic",
  });

  if (isMobile) {
    openTimeline
      .add({
        targets: ".drawer-container",
        translateY: ["100vh", 0],
        duration: 600,
      })
      .add({
        targets: "#OutageForm",
        opacity: [0, 1],
        duration: 600,
      });
  } else {
    openTimeline
      .add({
        targets: ".click-shield",
        opacity: [0, 0.5],
        duration: 250,
        begin: function () {
          const shield = document.querySelector(".click-shield") as HTMLElement;
          if (shield) {
            shield.style.display = "block";
          }
        },
      })
      .add({
        targets: ".drawer-container",
        translateX: [outageDrawerWidth, 0],
        duration: 600,
      })
      .add({
        targets: "#OutageForm",
        opacity: [0, 1],
        duration: 600,
      });
  }
};

export const closeDrawer = (
  isMobile: boolean,
  dispatch: AppDispatch,
  submittedOutage: ISubmittedOutage,
  searchMode: ISearchModeState,
  adminMode: IAdminModeState
): void => {
  const closeTimeline = anime.timeline({
    easing: "easeOutCubic",
  });

  if (isMobile) {
    closeTimeline
      .add({
        targets: "#confirmationContainer",
        opacity: [1, 0],
        duration: 600,
      })
      .add({
        targets: "#OutageForm",
        opacity: [1, 0],
        duration: 600,
      })
      .add({
        targets: ".drawer-container",
        translateY: [0, "100vh"],
        duration: 600,
        changeComplete: function () {
          if (submittedOutage.isSubmitted) {
            dispatch(clearSubmittedOutage());
          }

          if (adminMode.enabled) {
            dispatch(updateAdminModeState(false));
          }

          if (searchMode.enabled) {
            dispatch(clearSearchTerm());
            dispatch(clearSearchedOutages());
            dispatch(setSearchView({ activeView: ESearchWizardSteps.SEARCH }));
            dispatch(updateSearchModeState(false));
          }
        },
      });
  } else {
    closeTimeline
      .add({
        targets: "#OutageForm",
        opacity: [1, 0],
        duration: 600,
      })
      .add({
        targets: ".drawer-container",
        translateX: [0, outageDrawerWidth],
        easing: "easeInCubic",
        duration: 600,
        changeComplete: function () {
          if (submittedOutage.isSubmitted) {
            dispatch(clearSubmittedOutage());
          }

          if (adminMode.enabled) {
            dispatch(updateAdminModeState(false));
          }

          if (searchMode.enabled) {
            dispatch(clearSearchTerm());
            dispatch(clearSearchedOutages());
            dispatch(setSearchView({ activeView: ESearchWizardSteps.SEARCH }));
            dispatch(updateSearchModeState(false));
          }
        },
      })
      .add({
        targets: ".click-shield",
        opacity: [0.5, 0],
        easing: "easeInCubic",
        duration: 250,
        complete: function () {
          const shield = document.querySelector(".click-shield") as HTMLElement;
          if (shield) {
            shield.style.display = "none";
          }
        },
      });
  }
};
